<template lang="pug">
    app-modal(
      :closeOutside="false",
      titulo="Termo de compromisso",
      :width="700",
      @closeModal="cancelModal()",
    )
      template(slot="body")
        .termo-compromisso(v-if="tipoPagamento === 'PARCELADO'")
          termo-compromisso
        .container-checkbox()
          el-checkbox(@click="changeTermo(!isTermoAceito)" v-model="isTermoAceito" :disabled="visualizarTermo")
          span(@click="changeTermo(!isTermoAceito)" :class="{'checked': isTermoAceito}") {{tipoPagamento === 'PARCELADO' ? pagamentoParcelado : pagamentoAVista }}
      template(slot="footer")
        div(v-if="visualizarTermo && dataAceiteTermo")
          p.bold Aceito em: {{ formatDate(dataAceiteTermo, 'DD/MM/YYYY HH:mm:ss') }}
        div.buttons(v-if="!visualizarTermo")
          el-button(@click="cancelModal()") Cancelar
          el-button(
            type="primary",
            key="botao-confirma",
            :disabled="!isTermoAceito",
            @click="closeModal()"
          ) Confirmar
</template>

<script>
import format from '../utils/utils'
import axios from '@/utils/api'
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
const TermoCompromisso = () => import('@/components/estados/' + process.env.ESTADO + '/TermoCompromissoVtn')

export default {
  components: {
    AppModal,
    AppLabel,
    TermoCompromisso
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      pagamentoParcelado: `Declaro que li e estou de acordo com os termos e cláusulas acima citados,
      estou de acordo com os valores e confirmo a forma de pagamento escolhida.
      Estou ciente que não será possível alterar posteriormente a forma de pagamento.`,
      pagamentoAVista: `Declaro que estou de acordo com os valores e confirmo a forma de pagamento escolhida.
      Estou ciente que não será possível alterar posteriormente a forma de pagamento.`
    }
  },

  props: {
    tipoPagamento: {
      type: String,
      required: true
    },
    visualizarTermo: {
      type: Boolean,
      required: false,
      default: false
    },
    dataAceiteTermo: {
      type: Number,
      required: false
    },
    conteudo: {
      type: Number,
      required: false
    },
    isTermoAceito: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  async mounted () {
    if (this.visualizarTermo) {
      await this.getVtn()
    }
  },

  methods: {
    closeModal () {
      this.$emit('aceitarTermo')
    },

    changeTermo (value) {
      this.$emit('setTermo', value)
    },

    cancelModal () {
      this.$emit('setTermo', false)
      this.$emit('closeModal')
    },

    formatDate (data, formato) {
      return format.formatDate(data, formato)
    },

    async getVtn () {
      this.dadosVtn = await axios({
        method: 'GET',
        url: `financeiro/vtn/${this.conteudo}`
      })
      if (this.dadosVtn) {
        this.$store.commit('vtn/SET_VTN', this.dadosVtn)
      }
    }
  }

}
</script>

<style scoped lang="scss">
// @import '../../assets/styles/variables.scss'; Está carregando todo o node_module do element

$--color-primary: #009f61; // Importar o variables e retirar esta variavel quando juntar com o analise
$font-color: #606266;
$font-size-small: 0.875em;

.buttons {
  display: flex;
  justify-content: space-between;
}

.margin-top {
  margin-top: 10px;
}

.margin-right {
  margin-right: 10px;
}

.container-checkbox {
  margin-top: 10px;

  .el-checkbox {
    padding-right: 10px;
  }

  span {
    color: $font-color;
    font-size: $font-size-small;

    &.checked {
      color: $--color-primary;
    }
  }

  &:hover {
    cursor: pointer;

    & .el-checkbox /deep/ .el-checkbox__input .el-checkbox__inner {
      border-color: $--color-primary;
    }

    span {
      color: $--color-primary;
    }
  }
}

.termo-compromisso {
  padding: 10px;
  background-color: #ddd;
  border-radius: 3px;
}

.bold {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/AppModalTermoCompromissoVtn.vue